<mat-card>
  <app-generic-form adapter="teosto" formId="profile" [model]="model"></app-generic-form>
</mat-card>
